import { promiseWrapper } from 'utils/promise'

export interface PeggedPairConfig {
  sourcePair: string
  pegRate: number
}

interface PeggedPairConfigResponse {
  source_pair: string
  peg_rate: number
}

// Fetches PEGGED_CURRENCY_PAIRS from the backend (see src/inc/api/pegged-currency-pairs.php),
// so the source pair / peg rate config only has to be maintained in one place (PHP).
export const getPeggedCurrencyPairsFromAPI = async (): Promise<Record<string, PeggedPairConfig>> => {
  const data = await promiseWrapper<Record<string, PeggedPairConfigResponse>, never>(
    `${window.location.origin}/wp-json/support/pegged-currency-pairs`,
    'GET',
  )

  return Object.fromEntries(
    Object.entries(data).map(([pair, { source_pair, peg_rate }]) => [
      pair,
      { sourcePair: source_pair, pegRate: peg_rate },
    ]),
  )
}

// Cached promise for pegged currency pairs config, to avoid multiple API calls.
let peggedCurrencyPairsPromise: Promise<Record<string, PeggedPairConfig>> | null = null
export const getPeggedCurrencyPairs = (): Promise<Record<string, PeggedPairConfig>> => {
  if (!peggedCurrencyPairsPromise) {
    peggedCurrencyPairsPromise = getPeggedCurrencyPairsFromAPI().catch(() => ({}))
  }
  return peggedCurrencyPairsPromise
}
